export const badgeSlotStyles = {
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
};
